/** `[west, south, east, north]`, the Mapbox v6 bbox convention also used by
 *  `LocationsSuggestion#bbox`. */
export type Bbox = readonly [number, number, number, number];

/**
 * Mapbox v6 forward-geocoding feature types. Must match the server-side
 * `ALLOWED_TYPES` allowlist in
 * `apps/main/packs/world/app/contracts/world/contracts/search_locations_contract.rb`.
 */
export const MAPBOX_FEATURE_TYPES = [
  "country",
  "region",
  "district",
  "postcode",
  "place",
  "locality",
  "neighborhood",
  "address",
  "street",
] as const;

export type MapboxFeatureType = (typeof MAPBOX_FEATURE_TYPES)[number];

// Searchkit expects `insideBoundingBox` as `"neLat,neLng,swLat,swLng"`.
export function bboxToInsideBoundingBox([west, south, east, north]: Bbox): string {
  return `${north},${east},${south},${west}`;
}

// react-map-gl's `fitBounds` expects nested `[[w, s], [e, n]]` pairs.
export function bboxToFitBounds(bbox: Bbox): [[number, number], [number, number]] {
  return [
    [bbox[0], bbox[1]],
    [bbox[2], bbox[3]],
  ];
}
